import { newConfig } from '../config';
import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;

export default class NotificationRuleService {
  constructor(client) {
    this.client = client;
  }

  async getCompanyNotificationRules({ companyId, companyNotificationTypeId }) {
    const response = await this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/companies/${companyId}/notification-rules`,
      { params: { companyNotificationTypeId } }
    );
    return response.data;
  }

  async getCompanyNotificationTypes() {
    const response = await this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/company-notification-types`
    );
    return response.data;
  }

  async createCompanyNotificationRule({
    companyId,
    companyNotificationTypeId,
    groupCompanyId,
    policyId,
    emails
  }) {
    const response = await this.client.post(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/companies/${companyId}/notification-rules`,
      {
        companyNotificationTypeId,
        groupCompanyId,
        policyId,
        emails
      }
    );
    return response.data;
  }

  async updateCompanyNotificationRule({
    id,
    companyId,
    companyNotificationTypeId,
    groupCompanyId,
    policyId,
    emails
  }) {
    const response = await this.client.patch(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/companies/${companyId}/notification-rules/${id}`,
      {
        ...(companyNotificationTypeId ? { companyNotificationTypeId } : {}),
        ...(groupCompanyId ? { groupCompanyId } : {}),
        ...(policyId ? { policyId } : {}),
        emails
      }
    );
    return response.data;
  }

  async deleteCompanyNotificationRule({ id, companyId }) {
    const response = await this.client.delete(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/companies/${companyId}/notification-rules/${id}`
    );
    return response.data;
  }
}
